import dayjs from "dayjs";
import "dayjs/locale/mk"; // Macedonian
import "dayjs/locale/sq"; // Albanian
import "dayjs/locale/tr"; // Turkish
import "dayjs/locale/en"; // English
import customParseFormat from "dayjs/plugin/customParseFormat";

// Extend dayjs with plugins
dayjs.extend(customParseFormat);

// Map language codes to dayjs locale codes
const LOCALE_MAP = {
  en: "en",
  mk: "mk",
  sq: "sq",
  tr: "tr",
};

/**
 * Set the global dayjs locale based on language code
 * @param {string} languageCode - Language code (en, mk, sq, tr)
 */
export const setDayjsLocale = (languageCode) => {
  const locale = LOCALE_MAP[languageCode] || "en";
  dayjs.locale(locale);
};

/**
 * Get the current dayjs locale
 * @returns {string} Current locale code
 */
export const getDayjsLocale = () => {
  return dayjs.locale();
};

// Initialize with English by default
setDayjsLocale("en");

export default dayjs;
